import { render, staticRenderFns } from "./menu-tab.vue?vue&type=template&id=fe5b8896"
import script from "./menu-tab.vue?vue&type=script&lang=ts"
export * from "./menu-tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports